/**
 *
 * Asynchronously loads the component for SignUpFormV2
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { Loading } from 'components/Loading'

export default loadable({
  loader: () => import('./index' /* webpackChunkName: "SignUpFormV2" */),
  loading: <Loading />
})
